import { type FC, useState } from 'react';
import { SwalAlert } from '@/hooks/useSweetAlert';

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  className?: string;
}

export const ErrorState: FC<ErrorStateProps> = ({
  title = 'Error al cargar',
  message = 'No pudimos obtener los datos. Revisá tu conexión o intentá de nuevo.',
  onRetry,
  className = '',
}) => {
  const [retrying, setRetrying] = useState(false);

  const handleRetry = () => {
    if (!onRetry) return;
    setRetrying(true);

    setTimeout(() => {
      setRetrying(false);
      SwalAlert.success('Reintento exitoso', 'Los datos se cargaron correctamente.');
      onRetry();
    }, 800);
  };

  return (
    <div className={`flex flex-col items-center justify-center py-16 px-6 text-center ${className}`} role="alert">
      <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-red-50 border border-red-100 mb-5">
        <i className="ri-error-warning-line text-3xl text-red-500" />
      </div>
      <h3 className="text-base font-semibold text-foreground-900 mb-1.5">{title}</h3>
      <p className="text-sm text-foreground-500 max-w-sm mb-5">{message}</p>
      {onRetry && (
        <button
          onClick={handleRetry}
          disabled={retrying}
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 text-sm font-semibold rounded-lg transition-colors duration-150 cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <i className={`text-lg ${retrying ? 'ri-loader-4-line animate-spin' : 'ri-refresh-line'}`} />
          {retrying ? 'Reintentando...' : 'Reintentar'}
        </button>
      )}
    </div>
  );
};

export default ErrorState;